import React, { createContext, useContext, useState, useCallback } from 'react';
import { walletAPI, apiUtils } from '../service/api';

const WalletContext = createContext();

export const WalletProvider = ({ children }) => {
  const [plans, setPlans] = useState([]);
  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // क्रेडिट प्लान्स और वॉलेट बैलेंस लोड करने के लिए
  const fetchWalletData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await walletAPI.buyCredit();

      if (response.data.status === 'success') {
        const { plans, wallet, razorpay_key_id } = response.data.data;

        setPlans(plans);
        setWallet(wallet);

        return {
          success: true,
          plans,
          wallet,
          razorpayKey: razorpay_key_id
        };
      } else {
        const msg = response.data.message || 'डेटा लोड करने में विफल';
        setError(msg);
        return { success: false, message: msg };
      }
    } catch (err) {
      const errorData = apiUtils.handleError(err);
      setError(errorData.message);
      return { success: false, message: errorData.message };
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchTransactions = useCallback(async (params = {}) => {
    setLoading(true);
    try {
      const response = await walletAPI.showTransactions(params);
      if (response.data.success) {

        return { success: true, ...response.data.data };
      }
      return { success: false, message: response.data.message };
    } catch (err) {
      return { success: false, message: apiUtils.handleError(err).message };
    } finally {
      setLoading(false);
    }
  }, []);

  const clearWalletError = () => setError(null);

  const value = {
    plans,
    wallet,
    loading,
    error,
    fetchWalletData,
    fetchTransactions,
    clearWalletError
  };

  return (
    <WalletContext.Provider value={value}>
      {children}
    </WalletContext.Provider>
  );
};

export const useWallet = () => {
  const context = useContext(WalletContext);
  if (!context) {
    throw new Error('useWallet must be used within a WalletProvider');
  }
  return context;
};

export default WalletContext;